// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
})();


// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 7);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();

//faq tab
document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".faq-tab-btn");
  const panels = document.querySelectorAll(".faq-panel");

  function openFirstAccordion(panel) {
    if (!panel) return;

    let allDetails = panel.querySelectorAll("details");

    allDetails.forEach(d => d.removeAttribute("open"));

    if (allDetails.length > 0) {
      allDetails[0].setAttribute("open", true);
    }
  }

  let firstActivePanel = document.querySelector(".faq-panel.active");
  openFirstAccordion(firstActivePanel);

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      let targetId = this.dataset.tab;
      let targetPanel = document.getElementById(targetId);

      tabs.forEach(t => t.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));

      this.classList.add("active");
      targetPanel.classList.add("active");

      setTimeout(() => {
        openFirstAccordion(targetPanel);
      }, 50);
    });
  });

  document.querySelectorAll(".faq-item details").forEach(detail => {
    detail.addEventListener("toggle", function () {

      if (this.open) {
        let parentPanel = this.closest(".faq-panel");
        let allDetails = parentPanel.querySelectorAll("details");

        allDetails.forEach(d => {
          if (d !== this) {
            d.removeAttribute("open");
          }
        });
      }

    });
  });

});

// =============== promo announcement bar copy code js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {

    copyBtn.addEventListener("click", function () {

      let parent = this.closest(".copy-code-right");

      if (parent) {

        // let clone = parent.cloneNode(true);
        // clone.querySelector("span")?.remove();

        let codeText = parent.innerText.trim();

        navigator.clipboard.writeText(codeText).then(() => {

          let originalHTML = copyBtn.innerHTML;
          copyBtn.innerHTML = "&#10003;";

          setTimeout(() => {
            copyBtn.innerHTML = originalHTML;
          }, 2000);

        }).catch(err => {
          console.error("Copy failed", err);
        });

      }
    });

  });

  document.querySelectorAll(".discount-bar-close-icon").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      let bar = this.closest(".coupan-code");
      if (bar) bar.style.display = "none";
    });
  });

});

//tab-featured-collection js
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const target = this.dataset.tab;

      buttons.forEach(b => b.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});

document.addEventListener("change", function(e){

  if (e.target.matches('.card-swatch input[type="radio"]')) {
    const form = e.target.closest('variant-radios-card');
    if (!form) return;
    const variants = JSON.parse(
      form.querySelector('script[type="application/json"]').textContent
    );
    const selectedOptions = [];
    form.querySelectorAll('input[type="radio"]:checked').forEach(input => {
      selectedOptions.push(input.value);
    });
    const matchedVariant = variants.find(variant => {
      return variant.options.every((opt, index) => opt === selectedOptions[index]);
    });
    if (matchedVariant) {
      const url = form.dataset.url + '?variant=' + matchedVariant.id;
      window.location.href = url;
    }
  }
});


// serach in mobile
(function () {
  const stopEvent = (e) => {
    const searchArea = e.target.closest('.search-modal__form');
    if (!searchArea) return;

    e.stopPropagation();
  };

  document.addEventListener('mousedown', stopEvent, true);
  document.addEventListener('click', stopEvent, true);
  document.addEventListener('pointerdown', stopEvent, true);
})();


const heading = document.querySelector('.table-contents .heading');
const content = document.querySelector('.table-contents .content');

if (heading && content) {
  heading.addEventListener('click', () => {
    content.classList.toggle('active');
  });
}

const listItems = document.querySelectorAll('.table-contents ul.menu li');

if (listItems.length && content) {
  listItems.forEach((li) => {
    li.addEventListener('click', () => {
      content.classList.remove('active');
    });
  });
}